export default __webpack_public_path__ + "static/media/ICBC.dc111a1a.png";